import i18n from "i18next";
import {initReactI18next} from "react-i18next";

import itCommon from "@/locales/it.json";
import enCommon from "@/locales/en.json";

i18n.use(initReactI18next).init({
	fallbackLng: "en",
	resources: {
		it: {common: itCommon},
		en: {common: enCommon},
	},
	ns: ["common"],
	defaultNS: "common",
	interpolation: {escapeValue: false},
});

export default i18n;
